module.exports = __webpack_public_path__ + "img/banner3_tv.243e4df3.jpg";